module.exports = __webpack_public_path__ + "static/media/pinkyellowgradient.78d17e5f.jpg";